var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#000573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6C14.6868 6 13.3864 6.25866 12.1732 6.7612C10.9599 7.26375 9.85752 8.00035 8.92893 8.92893C7.05357 10.8043 6 13.3478 6 16C6 20.42 8.87 24.17 12.84 25.5C13.34 25.58 13.5 25.27 13.5 25V23.31C10.73 23.91 10.14 21.97 10.14 21.97C9.68 20.81 9.03 20.5 9.03 20.5C8.12 19.88 9.1 19.9 9.1 19.9C10.1 19.97 10.63 20.93 10.63 20.93C11.5 22.45 12.97 22 13.54 21.76C13.63 21.11 13.89 20.67 14.17 20.42C11.95 20.17 9.62 19.31 9.62 15.5C9.62 14.39 10 13.5 10.65 12.79C10.55 12.54 10.2 11.5 10.75 10.15C10.75 10.15 11.59 9.88 13.5 11.17C14.29 10.95 15.15 10.84 16 10.84C16.85 10.84 17.71 10.95 18.5 11.17C20.41 9.88 21.25 10.15 21.25 10.15C21.8 11.5 21.45 12.54 21.35 12.79C22 13.5 22.38 14.39 22.38 15.5C22.38 19.32 20.04 20.16 17.81 20.41C18.17 20.72 18.5 21.33 18.5 22.26V25C18.5 25.27 18.66 25.59 19.17 25.5C23.14 24.16 26 20.42 26 16C26 14.6868 25.7413 13.3864 25.2388 12.1732C24.7362 10.9599 23.9997 9.85752 23.0711 8.92893C22.1425 8.00035 21.0401 7.26375 19.8268 6.7612C18.6136 6.25866 17.3132 6 16 6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.bfaa55f72283e8ed91cd38e1d2dd176a.svg";
export { ForwardRef as ReactComponent };